/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { get } from 'utils/lodash'

const initialState = {
  density: 'comfortable', // Default density state
}

const persistentPaymentBatchesSlice = createSlice({
  name: 'persistentPaymentBatches',
  initialState: { ...initialState },
  reducers: {
    setDensity: (state, action) => {
      state.density = action.payload
    },
    resetState: () => initialState,
  },
})

export const { setDensity, resetState } = persistentPaymentBatchesSlice.actions

export const selectDensity = state => get(state, 'persistentPaymentBatches.density', 'comfortable')

export default persistentPaymentBatchesSlice.reducer
